import { useEffect, useRef, useState } from 'react'
import { Link } from 'react-router-dom'

// Building blocks shared by the Overview and the section summary pages
// (Sales, and the others as they are simplified): linked number tiles and
// titled cards, after PropertyBuk's dashboard.

/** The rendered width of an element, so the chart draws at 1:1 instead of
    scaling an 800px drawing down and leaving blank space around it. */
export function useWidth() {
  const ref = useRef(null)
  const [width, setWidth] = useState(0)
  useEffect(() => {
    if (!ref.current) return undefined
    const observer = new ResizeObserver(([entry]) => setWidth(Math.round(entry.contentRect.width)))
    observer.observe(ref.current)
    return () => observer.disconnect()
  }, [])
  return [ref, width]
}

/** A number that links to where it comes from. `tone="warn"` flags it;
    `trend` colours the note up (green) or down (red). */
export function Tile({ label, value, note, href, icon: Icon, tone, trend }) {
  return (
    <Link to={href} className={`sum-tile${tone ? ` tone-${tone}` : ''}`}>
      <span className="sum-tile-icon" aria-hidden="true"><Icon size={16} strokeWidth={1.75} /></span>
      <span className="sum-tile-label">{label}</span>
      <span className="sum-tile-value">{value}</span>
      {note && <span className={`sum-tile-note${trend ? ` trend-${trend}` : ''}`}>{note}</span>}
    </Link>
  )
}

export function Card({ title, action, children }) {
  return (
    <section className="sum-card">
      <div className="sum-card-header">
        <h2>{title}</h2>
        {action && <span className="sum-card-action">{action}</span>}
      </div>
      {children}
    </section>
  )
}
